export const getUserFullName = ({
  firstName,
  lastName,
}: {
  firstName?: string;
  lastName?: string;
}): string => (firstName && lastName ? `${firstName} ${lastName}` : "-");
